export const COOKIE_CONSENT_LOCALES = ['ca', 'de', 'en', 'es', 'eu', 'fr', 'gl'] as const;

export const COOKIE_CONSENT_REVISION = 2;

export const COOKIE_CONSENT_EXCLUDED_SEGMENTS = ['error', 'success'];

export const COOKIE_CATEGORY_NECESSARY = 'necessary';
export const COOKIE_CATEGORY_ANALYTICS = 'analytics';
export const COOKIE_CATEGORY_ADVERTISEMENT = 'advertisement';

export type CookieConsentLocale = (typeof COOKIE_CONSENT_LOCALES)[number];
